import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW0001Model } from "../kymw0001.model";

@Injectable()
export class GetMarkCodeListService extends PlessJsonResponderSub<any> {
  // VO
  vo = {
    OrderCode: '',
  };

  private successFunc: Function;
  // 処理に使用するModel
  private model: KYMW0001Model = new KYMW0001Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMarkCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        MarkCodeList: {
            condition:  {
                OrderCode: this.vo.OrderCode,
            }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureCodeListService
   */
  execute(vo, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW00getMarkCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureCodeListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
